import { render, staticRenderFns } from "./detialItem.vue?vue&type=template&id=7d2f4b44&scoped=true&"
import script from "./detialItem.vue?vue&type=script&lang=js&"
export * from "./detialItem.vue?vue&type=script&lang=js&"
import style0 from "./detialItem.vue?vue&type=style&index=0&id=7d2f4b44&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d2f4b44",
  null
  
)

export default component.exports